module.exports = __webpack_public_path__ + "img/about-1.b99f4f41.jpg";